(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('pricingService', pricingService);

    pricingService.$inject = ['$http', '$q', '$filter', '$log', 'guard'];

    function pricingService($http, $q, $filter, $log, guard) {
        var baseUrl = '/models/';

        return {
            getSalesPrice: getSalesPrice,
            formatPrice: formatPrice,
            formatUnavailableMoney: formatUnavailableMoney
        };

        function getSalesPrice(modelId, materialId, colourId, scale, quantity, productTemplateId, currencyId, canceler) {
            var params = {
                materialId: materialId,
                colourId: colourId,
                scale: scale,
                quantity: quantity,
                currencyId: currencyId,
                productTemplateId: productTemplateId
            };

            var requestUrl = baseUrl + modelId + "/price";
            var promise = $http.get(requestUrl, { params: params, canceler: canceler })
                .then(function (response) {
                    var salesPrice = response.data;

                    salesPrice.price.formatted = formatPrice(salesPrice.price);
                    salesPrice.priceDiscounted.formatted = formatPrice(salesPrice.priceDiscounted);
                    salesPrice.unitPrice.formatted = formatPrice(salesPrice.unitPrice);
                    salesPrice.unitPriceDiscounted.formatted = formatPrice(salesPrice.unitPriceDiscounted);

                    salesPrice.hasDiscount = function () {
                        return this.price.amount !== this.priceDiscounted.amount;
                    };

                    return salesPrice;
                })
                .catch(function (response) {
                    if (response === 'CANCELED') {
                        return $q.reject(response);
                    }

                    var error;
                    if (response.data && response.data.code) {
                        error = response.data;
                    } else {
                        error = {
                            code: 'UnexpectedError',
                            details: response
                        };
                    }

                    return $q.reject(error);
                });

            return promise;
        }

        function formatPrice(money, currency) {
            if (angular.isObject(money)) {
                return $filter('moneyFormat')(money.amount, money.currency);
            }

            if (angular.isNumber(money) && angular.isString(currency)) {
                return $filter('moneyFormat')(money, currency);
            }

            throw 'Invalid arguments';
        }

        function formatUnavailableMoney(money) {
            if (angular.isUndefined(money)) {
                return '--';
            }

            if (money === null) {
                return 'N/A';
            }

            return '';
        }
    }
}());